import React, { FC } from 'react';
import styles from './sub_header_content.module.scss';
import { Column } from '../grid/Grid';

export const SubHeaderContent: FC = ({ children }) => (
  <Column className={styles.content}>{children}</Column>
);
